import React from 'react';
import ReactDOM from 'react-dom/client'; // notice '/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import Login from './component/Login';
import './index.css';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  </Router>
);

serviceWorker.unregister();